module.exports = __webpack_public_path__ + "img/3@s.a5a92080.jpg";